import styled from 'styled-components';
import {
  ImageBck,
  Section as BaseSection,
  Typography,
} from '~/components/Atoms';
import { getThemeByPath } from '~/utils';

type AnimationProps = {
  isShowing?: boolean;
};

const animationDurationMS = 1000;
const defaultPersonImageHeight = 120;
const defaultPersonImageHeightMobile = 60;
const defaultExapmleImageHeight = 440;
const defaultSectionMinHeight = 640;

const radiusMedium = getThemeByPath('radius.medium');

const spacingMedium = getThemeByPath('spacings.medium');
const spacingInsane = getThemeByPath('spacings.insane');

const bkpTablet = getThemeByPath('breakpoints.tablet');

const handleExampleImageWrapperAnimationName = ({
  isShowing,
}: AnimationProps) => {
  return isShowing
    ? 'opacity-fade-in, padding-right-fade-in'
    : 'opacity-fade-out, padding-right-fade-out';
};

const handleReviewWrapperAnimationName = ({ isShowing }: AnimationProps) => {
  return isShowing
    ? 'opacity-fade-in, padding-left-fade-in'
    : 'opacity-fade-out, padding-left-fade-out';
};

export const Section = styled(BaseSection)`
  height: 100vh;
  min-height: ${defaultSectionMinHeight}px;
`;

export const TitleWrapper = styled.div`
  display: flex;
`;

export const Title = styled(Typography).attrs({
  variant: 'headline3',
})``;

export const FeedbackWrapper = styled.div`
  margin-top: ${spacingInsane}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 70%;

  @media (max-width: ${bkpTablet}px) {
    max-width: fit-content;
  }
`;

export const Centralizer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ExampleImageWrapper = styled.div<AnimationProps>`
  display: flex;
  width: 100%;
  animation-fill-mode: forwards;
  animation-name: ${handleExampleImageWrapperAnimationName};
  animation-duration: ${animationDurationMS}ms;
`;

export const ExampleImage = styled(ImageBck)`
  flex: 1;
  height: ${defaultExapmleImageHeight}px;
  border-radius: ${radiusMedium}px;
`;

export const ReviewWrapper = styled.div<AnimationProps>`
  display: flex;
  align-items: center;
  margin-top: ${spacingMedium}px;
  animation-fill-mode: forwards;
  animation-name: ${handleReviewWrapperAnimationName};
  animation-duration: ${animationDurationMS}ms;

  @media (max-width: ${bkpTablet}px) {
    align-items: flex-start;
  }
`;

export const PersonImageWrapper = styled.div`
  margin-right: ${spacingMedium}px;
`;

export const PersonImage = styled(ImageBck)`
  height: ${defaultPersonImageHeight}px;
  width: ${defaultPersonImageHeight}px;
  border-radius: ${defaultPersonImageHeight / 2}px;

  @media (max-width: ${bkpTablet}px) {
    height: ${defaultPersonImageHeightMobile}px;
    width: ${defaultPersonImageHeightMobile}px;
    border-radius: ${defaultPersonImageHeightMobile / 2}px;
  }
`;
